export enum WizardIntent {
  workspace = 'workspace',
  assessment = 'assessment',
  scenario = 'scenario',
  framework = 'framework',
}

export type WizzardWorkspaceType = {
  intent:
    | {
        type: WizardIntent.workspace;
        params: {
          createAssessment: boolean;
        };
      }
    | { type: WizardIntent.assessment }
    | { type: WizardIntent.framework }
    | {
        type: WizardIntent.scenario;
        params: {
          assessmentData: {
            id: string;
            name: string;
            review_date?: string | null;
            description?: string;
            started_date?: string;
          };
        };
      };
};

export enum WizardRecomendedControlsIntent {
  addScenarios = 'addScenarios',
  linkControls = 'linkControls',
}

export type WizardRecomendedControlsType = {
  intent:
    | { type: WizardRecomendedControlsIntent.addScenarios; params: { assessmentId: string; assessmentName: string } }
    | { type: WizardRecomendedControlsIntent.linkControls; params: { assessmentId: string; assessmentName: string } };
};

export type LinkControlsToScenarioModalTab = 'from_new' | 'from_existing' | 'from_suggested';
